import produce from 'immer';
import { ReducerAction } from 'store/modules/types';

// TYPES
import { Types, ConsultarParametroLocalidadesSigla } from './types';

export const INITIAL_STATE: ConsultarParametroLocalidadesSigla = {
	status: 0,
	data: null,
	enum: [],
	totalRegistrosConsulta: 0,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultarParametroLocalidadesSigla {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_PARAMETRO_LOCALIDADES_SIGLA: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.enum = INITIAL_STATE.enum;
				draft.totalRegistrosConsulta = INITIAL_STATE.totalRegistrosConsulta;
				break;
			}

			case Types.CONSULTAR_PARAMETRO_LOCALIDADES_SIGLA_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				if (action.payload.status === 204) {
					draft.totalRegistrosConsulta = 0;
				} else {
					draft.totalRegistrosConsulta = action.payload.data.localidades.length;
				}
				break;
			}

			case Types.CONSULTAR_PARAMETRO_LOCALIDADES_SIGLA_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.CONSULTAR_PARAMETRO_LOCALIDADES_SIGLA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.enum = INITIAL_STATE.enum;
				draft.totalRegistrosConsulta = INITIAL_STATE.totalRegistrosConsulta;
				break;
			}

			default:
		}
	});
}
